// extracted by mini-css-extract-plugin
export default {"container":"src-feature-form-__phone_container","remove":"src-feature-form-__phone_remove"};